module.exports = __webpack_public_path__ + "static/client6-9b77b179a8a2c18fd0565731182152e7.png";